import './App.css';
import React from 'react';
import Routes from './Routes';

import CssBaseline from '@material-ui/core/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Sys/App.scss';
import './theme/darkMode.css';
import { ColorModeProvider, useColorMode } from './theme/ColorModeProvider';
// import { CookieProvider } from 'Context/cookieProvider';
import { AuthProvider } from 'Context';
import ImpersonationBanner from './Components/ImpersonationBanner';

const ThemedToast = () => {
  const { mode } = useColorMode();
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={mode}
    />
  );
};

class App extends React.Component {
  render() {
    return (
      <AuthProvider>
        {/* <CookieProvider> */}
        <ColorModeProvider>
          <CssBaseline />
          <ImpersonationBanner />
          <ThemedToast />
          <Routes />
        </ColorModeProvider>
        {/* </CookieProvider> */}
      </AuthProvider>
    )
  }
}

export default App;
